import React, { useState, useEffect, useRef } from "react";
import "../../style/home.css";
import Sidebar from "../../components/sidebar";
import { BASE_URL } from "../../utils/config";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { useNavigate } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import Stack from "@mui/material/Stack";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Loading from '../../components/loading';
import TelegramWidget from "../../components/widget/telegramWidget";
const Commentry = () => {
  const [FormData, setFormData] = useState({
    CommentaryName: "",
    Description: "",
  });

  const [userdepartmentData, setUserdepartmentData] = useState({});
  const [loading,setLoading]=useState(true);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [loginuser, setLoginuser] = useState({});
  const [departmentvisible, setdepartmentVisible] = useState(false);
  const [departmentLists, setdepartmentLists] = useState([]);
  const [departmentList, setdepartmentList] = useState([]);
  const [deleteRoleIDDialog, setDeleteRoleIDDialog] = useState(false);
  const [editdepartmentDialog, setEditdepartmentDialog] = useState(false);
  const [filters, setFilters] = useState();
  const [filteredUserLists, setfilteredUserLists] = useState();
  const [messageDialog,setMessageDialog]=useState(false)
  const [isSuccess,setIsSuccess]=useState(false)
  const [isFailed,setIsFailed]=useState(false)
  const [ApiError,setApiError]=useState(false)
  const [errorMessage,setErrorMessage]=useState('')
  const [submitResponse,setSubmitResponse]=useState(false);
  const [successSave,setSuccessSave]=useState(false);
  const [successfail,setSuccessFail]=useState(false);
  const [updateSave,setUpdateSave]=useState(false);
  const [updatefail,setUpdateFail]=useState(false);
  const [validation,setValidation]=useState(false)
  const dt = useRef(null);
  const toast = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const columns = [
    { id: "S.No", label: "S.No", minWidth: 50, align: "center" },

    {
      id: "CommentaryName",
      label: "Commentary Name",
      minWidth: 70,
      align: "center",
    },
    {
      id: "Description",
      label: "Description",
      minWidth: 170,
      maxWidth:180,
      align: "center",
    },
    {
      id: "User_Name",
      label: "Created By",
      minWidth: 70,
      align: "center",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "center",
    },
  ];

  
  useEffect(() => {
    fetchdepartmentdata();
  }, []);


  // handle change page
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // handle change rows per page
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // this fucntion fetch all data of commentry form api
  const fetchdepartmentdata = async () => {
    console.log("Fetching Department");

    let loginuser = JSON.parse(localStorage.getItem("loginData"));
     await fetch(`${BASE_URL}/getallcommentery`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${loginuser.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if(res.success === true){
          setdepartmentLists(res.commenteryData[0]);
          setfilteredUserLists(res.commenteryData[0]);
          let loginuser = JSON.parse(localStorage.getItem("userdetails"));
          setLoginuser(loginuser);
          setLoading(false)
        }else if(res.status === 403){ 
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
        
        }, 2000)
        }
        else if(res.status === 401){
          
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
        
        }, 2000)
        }
        else{
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
        
        }, 2000)
        }
     
      }).catch((error)=>{
        setErrorMessage(`Error: ${error.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
        
        }, 2000)
        

      })
  };

  // this fucntion handle to create new commentry 
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(FormData, "messege===============");
    try {
      if (FormData.CommentaryName === "" || FormData.Description === "") {
      
         setValidation(true)
         setSubmitResponse(true)
         setTimeout(() => {
          setSubmitResponse(false)
          setValidation(false)
         }, 1700);

      } else {
        let loginuser = JSON.parse(localStorage.getItem("loginData"));

        let body = JSON.stringify({
          commenteryData: FormData,
          createdBy: loginuser.user_id,
          // description:description,
        });

        fetch(`${BASE_URL}/createcommentery`, {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/json",
              'Authorization': `Bearer ${loginuser.token}`
          },
        })
          .then((res) => res.json())
          .then((res) => {
            console.log("res", res);

            if (res.success === true) {
              setVisible(false);
              fetchdepartmentdata();
              setSuccessSave(true)
              setSubmitResponse(true)
             
              setTimeout(() => {
            
                setSubmitResponse(false);
                setSuccessSave(false)

              }, 1700); // Adjust the delay as needed (in milliseconds)
            } else if(res.status === 403){ 
              setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000) 
            }
            else if(res.status === 401){
              setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000) 
            }else {
            
              setSuccessFail(true)
              setSubmitResponse(true)
              setTimeout(() => {
                
                setSubmitResponse(false);
                setSuccessFail(false)

              }, 1700);
            }
          });
      }
    } catch (error) {
      console.log("error of the day", error);
      setSuccessFail(true)
      setSubmitResponse(true)
      setTimeout(() => {
        
        setSubmitResponse(false);
        setSuccessFail(false)

      }, 1700);
    }
  };

  // this fucntion handle update api
  const handleUpdate = async (e) => {
    e.preventDefault();
    console.log("userdepartmentData", userdepartmentData);
    try {
      if (userdepartmentData.CommentaryName === "" || userdepartmentData.Description === "") {
       
        setValidation(true)
        setSubmitResponse(true)
        setTimeout(() => {
         setSubmitResponse(false)
         setValidation(false)
        }, 1700);
      } else {
        let id = departmentList.id;
        let loginuser = JSON.parse(localStorage.getItem("loginData"));
        let body = JSON.stringify({
          commenteryData: userdepartmentData,
          modifiedBy: loginuser.user_id,
        });

        fetch(`${BASE_URL}/updateCommentery/${userdepartmentData.id}`, {
          method: "PUT",
          body,
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${loginuser.token}`
          },
        })
          .then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            if (res.success === true) {
              setEditdepartmentDialog(false);
              setdepartmentVisible(false);
              fetchdepartmentdata();
             
              setUpdateSave(true)
              setSubmitResponse(true);
              setTimeout(() => {
                
                setSubmitResponse(false);
                setUpdateSave(false)

              }, 1700); 
              
            } else if(res.status === 403){ 
              setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000) 
            }
            else if(res.status === 401){
              setErrorMessage(`Error: ${res.message}`)
              setApiError(true);
             setMessageDialog(true); 
             setLoading(false)
             setTimeout(() => {
              
              setMessageDialog(false); 
              setApiError(false);
              localStorage.clear()
                 navigate('/login')
                  },3000) 
            }else {
              
              setUpdateFail(true)
      setSubmitResponse(true)
      setTimeout(() => {
        
        setSubmitResponse(false);
        setUpdateFail(false)

      }, 1700);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            setUpdateFail(true)
            setSubmitResponse(true)
            setTimeout(() => {
              
              setSubmitResponse(false);
              setUpdateFail(false)
      
            }, 1700);
            
          });
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage(`Error: ${error.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000) 
    }
  };

  // this fucntion handle change of input fields

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...FormData,
      [name]: value,
    });
  };

  // this function handle change of update fields
  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    setUserdepartmentData({
      ...userdepartmentData,
      [name]: value,
    });
  };

  //for the datatable
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={ ()=>setVisible(true)}
          >
            Add Commentary
          </Button>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };
  const leftToolbarTemplate = () => {
    return (
      <>
        <span className="p-input-icon-left table-search">
          <i className="pi pi-search" />
          <InputText
            type="search"
            value={filters}
            onInput={handleSearch}
            placeholder="Search..."
          />
        </span>
      </>
    );
  };

  // this function is used to search item 
  const handleSearch = (event) => {
    let filetertext = event.target.value;
    setFilters(event.target.value);
    setPage(0);
    setfilteredUserLists(departmentLists.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === 'string' &&
          value.toLowerCase().includes(filetertext.toLowerCase())
      )))
  };

  // this function is used to render action div in a row
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment className="actions">
        <i
          className="pi pi-user-edit"
          style={{ cursor: "pointer" , marginRight:"10px"}}
          title="Edit"
          onClick={() => confirmEditdepartment(rowData)}
        ></i>

        <i
          className="pi pi-trash"
          style={{ color: "#ff4d4d", cursor: "pointer" }}
          title="Delete"
          onClick={() => confirmDeleteProduct(rowData)}
        ></i>
      </React.Fragment>
    );
  };
  //export the excel file
  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(departmentLists);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Commentry_list");
    });
  };

  //  this function is used to save excel sheet in user local system
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        const date = new Date();

        // Extract date components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        // Extract time components
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");

        // Combine date and time components
        const dateTime = `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;

        module.default.saveAs(
          data,
          fileName + "_export_" + dateTime + EXCEL_EXTENSION
        );
      }
    });
  };

  //  this fucntion is used to hide delete dialog box
  const hideDeleteProductDialog = () => {
    setDeleteRoleIDDialog(false);
  };

  // this function open  a delete dialog box
  const confirmDeleteProduct = (departmentlist) => {
    setdepartmentList(departmentlist);
    setDeleteRoleIDDialog(true);
  };

  // this function is used to delete the commentry
  const deleteProduct = async () => {
    let id = departmentList.id;
    let body = JSON.stringify({ modified_by: loginuser.user_name });
    let loginData = JSON.parse(localStorage.getItem("loginData"));
     await fetch(`${BASE_URL}/deletedCommentery/${id}`, {
      method: "DELETE",
      body,
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${loginData.token}`
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if (res.success === true) {
          let _products = departmentLists.filter(
            (val) => val.id !== departmentList.id
          );
          setdepartmentLists(_products);
          setfilteredUserLists(_products);
          setDeleteRoleIDDialog(false);
          setdepartmentList("");

          setIsSuccess(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsSuccess(false);
          
          }, 1700)
        } else if(res.status === 403){ 
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000)  
        }
        else if(res.status === 401){
           
          setErrorMessage(`Error: ${res.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          localStorage.clear()
             navigate('/login')
              },3000) 
        }else {
          

          setIsFailed(true);
          setMessageDialog(true);

          setTimeout(() => {
            setMessageDialog(false); 
            setIsFailed(false);
          
          }, 1700);
        }
      }).catch((error)=>{
        setErrorMessage(`Error: ${error.message}`)
          setApiError(true);
         setMessageDialog(true); 
         setLoading(false)
         setTimeout(() => {
          
          setMessageDialog(false); 
          setApiError(false);
          
              },3000) 
      })
  };


  //  thsi function is used to hide the edit dialog box
  const hideEditdepartmentDialog = () => {
    setEditdepartmentDialog(false);
  };

//  this dialog box open edit dialog box
  const confirmEditdepartment = async (departmentlist) => {
    setdepartmentList(departmentlist);
    setEditdepartmentDialog(true);
  };
  // edit box confirm
  const handledepartmentConfirm = async () => {
    setEditdepartmentDialog(false);
    setdepartmentVisible(true);

    let loginuser = JSON.parse(localStorage.getItem("userdetails"));
    setLoginuser(loginuser);
    setUserdepartmentData(departmentList);
    console.log(departmentList.CommentaryName, "departmentList");
    setTimeout(() => {
      document.getElementById("EditCommentaryName").value =
        departmentList.CommentaryName;
      document.getElementById("EditDescription").value =
        departmentList.Description;
    }, 500);
  };


  return (
    <div>
      <Sidebar />
      {loading?
      <div style={{position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 2,}}>
        <Loading/>
      </div>:
      <div className="add-user user-list">
        {/* <div className="container-fluid m-0 p-0"> */}
        <div className="container">
          <h2 style={{ fontSize: "24px" }}>Commentary List</h2>
          <Toast ref={toast} position="top-center" />
          <Toolbar
            className="table-pre-head"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>
       
          {/* 💡💡💡💡💡💡💡💡table💡💡💡💡💡💡💡💡 */}
          <div className="table">
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead style={{ backgroundColor: "#98C2EC" }}>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {filteredUserLists.length > 0?(
                  <TableBody>

                    {filteredUserLists
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.email_address}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.id === "S.No"
                                    ? index + 1
                                    : column.id === "user_name"
                                    ? `${row.first_name} ${
                                        row.middle_name || ""
                                      } ${row.last_name}`
                                    : column.id === "Action"
                                    ? actionBodyTemplate(row)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                  ):null}
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUserLists.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>

          <TelegramWidget/>
     

          {/* 💡💡💡💡💡💡💡💡add user pop up💡💡💡💡💡💡💡💡 */}
          <Dialog className="popup-addcommentry"
            open={visible}
            onClose={() => setVisible(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Add Commentary"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  <label
                    htmlFor="CommentaryName">Commentary Name:<span style={{color:'red'}}>*</span> </label>{" "}
                  <br></br>
                  <InputText
                    id="CommentaryName"
                    name="CommentaryName"
                    onChange={handleChange}
                    style={{ width: "100%",  }}             
                  />
                  <br></br>
                  <label htmlFor="Description"> Description:<span style={{color:'red'}}>*</span> </label>
                  <InputTextarea
                    id="Description"
                    name="Description"
                    style={{
                      width: "100%",                      
                      height: "200px",
                    }}
                    autoResize={true}
                    onChange={handleChange}
                  />
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={() => setVisible(false)}
              >
                Cancel
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={handleSubmit}
                autoFocus
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

      

          {/*💡💡💡💡💡💡💡💡 edit user pop up 💡💡💡💡💡💡💡💡 */}
          <Dialog className="popup-editcommentry"
            open={departmentvisible}
            onClose={() => {
              setVisible(false);
              setdepartmentVisible(false);
              setEditdepartmentDialog(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Edit Commentary"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  <label htmlFor="commentaryName" > Commentary Name:<span style={{color:'red'}}>*</span> </label>{" "}
                  <br></br>
                  <InputText
                    id="EditCommentaryName"
                    name="CommentaryName"
                    style={{ width: "100%",  }}  
                    onChange={handleUpdateChange}
                  />
                  <br></br>
                  <label htmlFor="description"> Description:<span style={{color:'red'}}>*</span> </label>
                  <InputTextarea
                    id="EditDescription"
                    name="Description"
                    style={{
                      width: "100%",
                      height: "200px",
                    }}
                    autoResize={true}
                    onChange={handleUpdateChange}
                  />
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={() => setdepartmentVisible(false)}
              >
                Cancel
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={handleUpdate}
                autoFocus
              >
                Update
              </Button>
            </DialogActions>
          </Dialog>

       

          {/*💡💡💡💡💡💡💡💡 delete user dialog 💡💡💡💡💡💡💡💡💡💡*/}
          <Dialog className="popup-editcommentry"
            open={deleteRoleIDDialog}
            onClose={hideDeleteProductDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <span style={{ color: "black" }}>
                  Are you sure, you want to delete this commentary?
                </span>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideDeleteProductDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={deleteProduct}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

      

          {/*💡💡💡💡💡💡💡💡 Edit user dialog 💡💡💡💡💡💡💡💡*/}
          <Dialog className="popup-editcommentry"
            open={editdepartmentDialog}
            onClose={hideEditdepartmentDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
              {"Confirm Edit"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <span style={{ color: "black" }}>
                  Are you sure, you want to edit this commentary ?
                </span>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className="btn-cancel"
                variant="outlined"
                color="error"
                onClick={hideEditdepartmentDialog}
              >
                No
              </Button>
              <Button className="btn-submit"
                variant="outlined"
                color="success"
                onClick={handledepartmentConfirm}
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>


           {/* error message dialog */}
           <Dialog
      open={messageDialog}
      onClose={()=>{setMessageDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      
       {isSuccess?<h4 style={{ color: "green"}}>Success</h4>:null}
       {isFailed?<h4 style={{ color: "red" }}>Failure</h4>:null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
            
              {isSuccess ? 
               <span style={{ color: "black" }}>
                  Commentary Successfully Deleted.
                </span>
               : null}
                {isFailed?
                <span style={{ color: "black" }}>
                  Failed To Delete Commentary.
                </span>:null}

                {ApiError?
                <span style={{ color: "black" }}>
                   {errorMessage}
                </span>:null}

              
           
        
        </DialogContentText>
      </DialogContent>
     
    </Dialog>

    
           {/*create and update error message dialog */}
           <Dialog
      open={submitResponse}
      onClose={()=>{setSubmitResponse(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle  id="alert-dialog-title">
      
       {successSave?<h4 style={{ color: "green"}}>Success</h4>:null}
       {updateSave?<h4 style={{ color: "green"}}>Success</h4>:null}
       {successfail?<h4 style={{ color: "red" }}>Failure</h4>:null}
       {updatefail?<h4 style={{ color: "red" }}>Failure</h4>:null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         
            
              {successSave ? 
               <span style={{ color: "black" }}>
                  Commentary Successfully Created.
                </span>
               : null}
                {successfail?
                <span style={{ color: "black" }}>
                  Failed To Create Commentary.
                </span>:null}

                {updateSave ? 
               <span style={{ color: "black" }}>
                  Commentary Successfully Updated.
                </span>
               : null}
                {updatefail?
                <span style={{ color: "black" }}>
                  Failed To Update Commentary.
                </span>:null}

                {validation?
                <span style={{ color: "black" }}>
                 <span style={{color:'red'}}>*</span> Please Fill All Mendatory Field.
                </span>:null}
              
           
        
        </DialogContentText>
      </DialogContent>
     
    </Dialog>
        </div>
      </div>}
    </div>
  );
};

export default Commentry;
